const timeGroup = {
    hour: "Hour",
    day: "Day",
    week: "Week",
    month: "Month",
};

export default timeGroup;
